import { render, staticRenderFns } from "./LicensesAvai.vue?vue&type=template&id=004b2d2a&scoped=true&"
import script from "./LicensesAvai.vue?vue&type=script&lang=js&"
export * from "./LicensesAvai.vue?vue&type=script&lang=js&"
import style0 from "./LicensesAvai.vue?vue&type=style&index=0&id=004b2d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b2d2a",
  null
  
)

export default component.exports